import { guidEmpty } from "utils/guid-empty";

export class FaturaLiquidarModel {
    constructor(
        public id: string = guidEmpty(),
        public formaPagamentoId: string = guidEmpty(),
        public valor: number = 0,
        public dataHora: string = '',
    ) { }
}